export const aboutContent = {
  brand: {
    title: '让每个人都能轻松拥有专属导航页',
    story: `导航页在线发布诞生于一个简单的想法：为什么创建一个导航页需要那么复杂？

我们的创始团队来自互联网行业，在多年的工作中发现，无论是团队内部的知识管理，还是面向用户的资源导航，一个简洁好用的导航页都是刚需。然而，现有的方案要么需要技术背景搭建，要么功能简陋。

于是，我们决定打造一个零代码、高颜值、功能强大的导航页在线发布平台。经过一年多的研发和打磨，导航页在线发布正式上线。

我们的使命是让每个人——无论是个人用户、创业团队还是大型企业——都能在几分钟内创建并发布一个专业的导航页，无需任何技术背景。

截至目前，已有超过 50,000 个导航页通过我们的平台创建，累计服务超过 200 万月访问量。未来，我们将持续优化产品，为更多用户提供更好的导航页创建体验。`,
  },
  stats: [
    { value: '50,000+', label: '已创建导航页' },
    { value: '30,000+', label: '注册用户' },
    { value: '200万+', label: '月页面访问' },
    { value: '99.9%', label: '服务可用性' },
  ],
  reputation: {
    title: '用户口碑',
    subtitle: '听听真实用户怎么说',
    reviews: [
      {
        name: '陈思远',
        role: '产品经理 · 某互联网公司',
        avatar: 'CSY',
        rating: 5,
        content: '产品思路很清晰，功能设计恰到好处——不多不少。我们团队用导航页在线发布替代了之前维护的Wiki首页，效率提升明显。分类管理和拖拽排序的交互体验很流畅。',
      },
      {
        name: '赵雪梅',
        role: '运营总监 · 电商品牌',
        avatar: 'ZXM',
        rating: 5,
        content: '把运营常用的几十个工具网站集中到一个导航页，分享给团队每人设为浏览器首页，新员工培训也省了很多时间。客户成功团队的服务响应很快。',
      },
      {
        name: '刘浩然',
        role: '独立开发者',
        avatar: 'LHR',
        rating: 5,
        content: '作为一个独立开发者，我需要给用户提供一个干净的工具导航。用了导航页在线发布后，只需要专注收集好用的工具链接，不用再操心页面维护。自定义域名绑定功能很实用。',
      },
      {
        name: '黄雅文',
        role: '高校教师',
        avatar: 'HYW',
        rating: 4,
        content: '我把课程相关的学习资源、参考网站、工具链接整理成导航页分享给学生，大家反馈说找资料方便多了。希望能增加更多教育相关的模板。',
      },
      {
        name: '孙伟强',
        role: '技术负责人 · 创业团队',
        avatar: 'SWQ',
        rating: 5,
        content: '创业初期资源有限，用导航页在线发布快速搭建了团队内部工具导航，零成本零维护。随着团队扩大升级到企业版，权限管理功能很好地满足了多人协作的需求。',
      },
      {
        name: '周晓琳',
        role: '自由职业者',
        avatar: 'ZXL',
        rating: 5,
        content: '我同时接多个项目，每个项目用到的工具和资源都不一样。创建多个导航页按项目分类管理，切换起来很方便。主题定制功能让每个导航页都能匹配项目风格。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '有任何问题或合作意向，欢迎随时联系我们',
    email: 'hello@daohangye.com',
    wechat: 'daohangye-official',
    hours: '周一至周五 9:00 - 18:00',
  },
};